import { render, staticRenderFns } from "./VpOverlay.vue?vue&type=template&id=0c7e73c4&"
import script from "./VpOverlay.vue?vue&type=script&lang=js&"
export * from "./VpOverlay.vue?vue&type=script&lang=js&"
import style0 from "./VpOverlay.vue?vue&type=style&index=0&id=0c7e73c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports